const groupPrefix = createApiRoute(ApiModule.DIETARY, ApiDataModel.DIET)

export const apiPriceDiets = {
	updatePriceDiets: async (dietId: number, priceTiers: IDietsPriceModel[]) => {
		const { data } = await apiCommon<IDietsPrice[]>(`${groupPrefix}/${dietId}/prices`, {
			method: 'PUT',
			body: { prices: priceTiers.map(priceTier => priceDietToJSON(priceTier)) },
		})
		return { data: data.map(d => PriceDiet(d)) }
	},
}
